import React from "react";
import { Status } from "../../types/statusTypes";
import { getStatusDisplayText } from "../../helpers/statusMapper";

interface QueueVolumeCardListItemProps {
  status: Status;
  count: number;
}

export default function QueueVolumeCardListItem({ status, count }: QueueVolumeCardListItemProps) {
  return (
    <li className={`list-group-item flex-fill border-0 rounded-0 bg-${status} bg-opacity-50`}>
      <b>{getStatusDisplayText(status)}:</b> {count}
    </li>
  );
}
